'use client'
import React from 'react'
import NewsListItem from '../news/NewsListItem';
import PaginatedList from './PaginatedList';

export default function SpotlightNewsPagination(props) {
  const { items, wrapperClassName } = props;
  return (
    <PaginatedList items={items} wrapperClassName={wrapperClassName} ItemComponent={ItemComponent} />
  )
}


const ItemComponent = ({ item }) => {
  return (
    <NewsListItem item={item} />
  )
}